import React, { useState } from 'react';

interface ImageWithFallbackProps {
  src: string;
  alt?: string;
  defaultSrc: string;
  className?: string;
}

const ImageWithFallback = ({ src, alt = 'Image', defaultSrc, className } : ImageWithFallbackProps) => {
  const [imgSrc, setImgSrc] = useState(src);

  const handleError = () => {
    setImgSrc(defaultSrc);
  };

  return (
    <img
      src={imgSrc}
      alt={alt}
      onError={handleError}
      className={className}
      style={{ width: '100%', height: 'auto' }}
    />
  );
};

export default ImageWithFallback;